export default {"src":"/_next/static/media/facebook-round.1065364d.svg","height":50,"width":50};